import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-256adc37"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "activity-tag-list",
  id: "tagList"
}
const _hoisted_2 = { class: "activity-tag-wrapper" }
const _hoisted_3 = { class: "xag-flex tag-list" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "全部机型", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "form-main" }
const _hoisted_8 = { class: "activity-container" }
const _hoisted_9 = { class: "price" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "price-extra" }, "(含定金1000)", -1))
const _hoisted_11 = {
  key: 0,
  class: "no-data-box xag-flex-center"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "device-no-data-icon replace-v3-icon" }, null, -1))
const _hoisted_13 = { class: "record-no-data-tips" }
const _hoisted_14 = {
  key: 0,
  class: "form-footer xag-page__footer xag-flex-vertical device-replace-button-wrap"
}
const _hoisted_15 = { class: "tips" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "已阅读并同意", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { ref, Ref, toRef, reactive, computed, ComputedRef, watch } from 'vue'
import AppHeader from '@/components/Header.vue'
import { useRouter, Router } from 'vue-router'
import { useStore } from 'vuex'
import { isApp } from '@/utils/app'
import getRoute from '@/compositions/route'
import ActivityProduct from './components/activity-product-item.vue'
import {
  ActivityTagItem,
  ActivityListItem,
  ShowProductItem,
  FilterItem,
} from '@/types/device-replace-v3'
import {
  getActivityTagList,
  getActivityList,
  sumbitDeviceApply,
  changeApplyActivity,
} from '@/apis/device-replace-v3'
import { Toast, RadioGroup, Radio, Checkbox, Button, Dialog } from 'vant'
import { showToastLoading, clearToast } from '@/utils/tools'
import {
  userDeviceCacheKey,
  brandCacheKey,
  cacheTagListKey,
  cacheActivityListKey,
} from './definition'
import FilterPopup from './components/filter-popup.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'apply-choose-device',
  setup(__props) {

const checkColor = '#00B359'
const $router: Router = useRouter()
const { query } = getRoute()
const recordGuidQuery = (query.value.record as string) || ''
const productGuidQuery = (query.value.product as string) || ''
// 以上两项更改套餐时会传过来
const parameterKey = (query.value.key as string) || ''
const appHeaderText: ComputedRef<string> = computed(() => {
  return recordGuidQuery ? '更改套餐' : '购买机型'
})
const buttonText = computed(() => {
  return recordGuidQuery ? '确认更改' : '支付定金'
})
let parameter = reactive({
  radio_isXAG: '1',
  radio_substitution: '',
  radio_complete: '',
  radio_undamaged: '',
  radio_match: '', //是否符合补贴要求
  radio_completeAndUndamaged: '', // 功能，部件是否完好
  model: '',
  brand: '',
  brand_name: '',
  model_type: '',
  model_type_text: '',
  product_sn: '',
  code: '',
  product_name: '',
  client_guid: '',
  client_name: '',
  exchange_activity_guid: '', //活动guid
  payment: 'wx', //支付方式 wx-微信 zs-聚合支付
  source: isApp ? 'app' : 'mini', //app/小程序
})

function setDataCache() {
  sessionStorage.setItem(
    parameterKey,
    JSON.stringify({
      parameter: { ...parameter },
      termsAgreed: termsAgreed.value,
      filterItems: filterItems,
    })
  )
  // 缓存tag相关内容
  sessionStorage.setItem(
    cacheTagListKey,
    JSON.stringify({
      tagList: tagList.value,
      tag: tag.value,
    })
  )
  // 缓存套装相关内容
  sessionStorage.setItem(
    cacheActivityListKey,
    JSON.stringify({
      activityList: activityList.value,
      checkedActivityGuid: checkedActivityGuid.value,
    })
  )
}
function clearCache(caches: string[]) {
  caches.map((key) => {
    sessionStorage.removeItem(key)
  })
}

function initPageData() {
  // 获取parameter缓存
  let cacheJsonDetail = sessionStorage.getItem(parameterKey)
  if (cacheJsonDetail) {
    const cacheData = JSON.parse(cacheJsonDetail)
    for (let key in cacheData.parameter) {
      parameter[key] = cacheData.parameter[key]
    }
    if (cacheData.filterItems) {
      for (let key in cacheData.filterItems) {
        filterItems[key] = cacheData.filterItems[key]
      }
    }
    termsAgreed.value = cacheData?.termsAgreed || false
  }
  fetchTagList()
}

// function viewGuide() {
//   setDataCache()
//   $router.push({ name: 'device-replace-v3-apply-choose-guide' })
// }
function checkProtocol() {
  setDataCache()
  $router.push({
    path: '/protoc',
    query: {
      title: '极飞农业无人机优惠购机须知',
      url: 'https://app.xag.cn/help_doc/a966ba16-dae3-48be-9fc4-7e66213f8fc3',
    },
  })
}

// 选中
const checkedActivityGuid: Ref<string> = ref('')
const tag: Ref<string> = ref('')
function setTag(t: string) {
  tag.value = t
  fetchActivityList()
}
const tagList: Ref<ActivityTagItem[]> = ref([])
async function fetchTagList() {
  let data
  let tagChecked = ''
  let cacheJsonDetail = sessionStorage.getItem(cacheTagListKey)
  if (cacheJsonDetail) {
    const cacheData = JSON.parse(cacheJsonDetail)
    data = cacheData.tagList
    tagChecked = cacheData.tag
    sessionStorage.removeItem(cacheTagListKey)
  } else {
    showToastLoading({
      message: '加载中',
    })
    try {
      data = await getActivityTagList()
      tagChecked = '' // 默认为全部机型
    } catch (error) {}
  }
  clearToast()
  tag.value = tagChecked
  tagList.value = data
  fetchActivityList()
}

const filterItems: FilterItem = reactive({
  version: '',
  charge: '',
  control: '',
})
const hasFilterItems = computed(() => {
  for (let key in filterItems) {
    if (filterItems[key] !== '') {
      return true
    }
  }
  return false
})
function updateFilterItems(items: FilterItem) {
  for (let key in filterItems) {
    filterItems[key] = items[key]
  }
}
const filterWrap = ref<any>()
const filterPopupTop = computed(() => {
  return filterWrap?.value?.getBoundingClientRect().top || 0
})

const activityList: Ref<ActivityListItem[]> = ref([])
const productList = computed(() => {
  let productArray: ShowProductItem[] = [] as ShowProductItem[]
  activityList.value.map((item) => {
    let exchange_activity_guid = item.guid
    item.product.map((product) => {
      productArray.push({
        ...product,
        exchange_activity_guid: exchange_activity_guid,
      })
    })
  })
  return productArray || []
})
// 过滤套装
const productListAfterFilter = computed(() => {
  let list: ShowProductItem[] = [] as ShowProductItem[]
  // 过滤已选套餐
  list = productList.value.filter((item) => {
    return item.guid !== productGuidQuery
  })
  // 过滤关键词
  for (let key in filterItems) {
    list = list.filter((item) => {
      return item.name.indexOf(filterItems[key]) !== -1
    })
  }
  console.log('list-after-filter', list)
  return list || []
})
watch(
  () => productListAfterFilter.value,
  (newVal) => {
    if (checkedActivityGuid.value) {
      let findItem =
        productListAfterFilter.value.find((item) => {
          return item.exchange_activity_guid === checkedActivityGuid.value
        }) || undefined
      if (!findItem) checkedActivityGuid.value = ''
    }
  }
)

async function fetchActivityList() {
  let data
  let checkedGuid = ''
  let cacheJsonDetail = sessionStorage.getItem(cacheActivityListKey)
  if (cacheJsonDetail) {
    const cacheData = JSON.parse(cacheJsonDetail)
    data = cacheData.activityList
    checkedGuid = cacheData.checkedActivityGuid
    sessionStorage.removeItem(cacheActivityListKey)
  } else {
    showToastLoading({
      message: '加载中',
    })
    try {
      let result = await getActivityList(tag.value ? { tag: tag.value } : {})
      data = result || []
      checkedGuid = ''
    } catch (error) {
      console.log('error', error)
    }
  }
  activityList.value = data
  checkedActivityGuid.value = checkedGuid
  clearToast()
}
const termsAgreed = ref(false)
function verifyParameter(): boolean {
  let message = ''
  if (!parameter.exchange_activity_guid) {
    message = '未选购套餐'
  } else if (!termsAgreed.value) {
    message = '请阅读并同意《极飞农业无人机优惠购机须知》'
  }
  if (message) {
    Toast(message)
    return false
  }
  return true
}
const canSubmit: ComputedRef<boolean> = computed(() => {
  return checkedActivityGuid.value && termsAgreed.value
})

const checkedProduct = computed(() => {
  let findItem =
    productListAfterFilter.value.find((item) => {
      return item.exchange_activity_guid === checkedActivityGuid.value
    }) || undefined
  return findItem
})
async function sumbit() {
  parameter.exchange_activity_guid = checkedActivityGuid.value
  if (!verifyParameter()) return
  let product = checkedProduct.value
  console.log('选中product', product)
  if (product && product.name.indexOf('轻简版') !== -1) {
    // 选中套装名称中含有 轻简版
    return Dialog.confirm({
      message:
        '申请轻简版套餐可能不满足农机局要求的“四电一充”配置。若需办理农机补贴，建议咨询当地农机局确认后谨慎选购。',
      confirmButtonText: '确认选购',
      cancelButtonText: '考虑看看',
      className: 'repair-dialog',
      width: 304,
    })
      .then(() => {
        console.log('继续选购')
        doSubmit()
      })
      .catch(() => {
        console.log('考虑看看')
      })
  }
  doSubmit()
}
async function doSubmit() {
  console.log('doSubmit')
  if (recordGuidQuery) {
    doChangeApplyActivity()
  } else {
    showToastLoading({
      message: '提交申请...',
    })
    try {
      let params = {
        ...parameter,
        radio_substitution: Number(parameter.radio_substitution),
        radio_complete: Number(parameter.radio_complete),
        radio_undamaged: Number(parameter.radio_undamaged),
        brand: Number(parameter.brand),
        model_type: Number(parameter.model_type),
      }
      delete params.radio_isXAG
      delete params.brand_name
      delete params.model_type_text
      delete params.radio_match
      delete params.radio_completeAndUndamaged
      // 极飞品牌 model_type不传
      if (params.brand === 1) {
        delete params.model_type
      }
      let data = await sumbitDeviceApply(params)
      clearToast()
      clearCache([parameterKey, cacheTagListKey, userDeviceCacheKey, brandCacheKey])
      $router.replace({
        name: 'device-replace-v3-pay-front-money',
        query: { guid: data.res.exchange_order_guid },
      })
    } catch (error) {
      clearToast()
      console.log('订单申请失败-error', error)
      let message = error && error.message ? error.message : '申请失败'
      Dialog({
        message,
        confirmButtonText: '我知道了',
        className: 'device-replace-v3-dialog',
        width: 304,
      })
    }
  }
}
async function doChangeApplyActivity() {
  showToastLoading({
    message: '更改套餐...',
  })
  try {
    await changeApplyActivity({
      exchange_activity_guid: checkedActivityGuid.value,
      guid: recordGuidQuery,
    })
    clearToast()
    setTimeout(() => {
      $router.replace({
        name: 'device-replace-v3-record-detail',
        query: { guid: recordGuidQuery },
      })
    }, 500)
  } catch (error) {
    clearToast()
    console.log('套餐更改失败', error)
    let message = error && error.message ? error.message : '套餐更改失败'
    Dialog({
      message,
      confirmButtonText: '我知道了',
      className: 'device-replace-v3-dialog',
      width: 304,
    })
  }
}

const popupsShow = ref(false)
function onUpdatePopupShow(show: boolean) {
  popupsShow.value = show
}
initPageData()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: _unref(appHeaderText) }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(["tag-item", tag.value === '' ? 'checked' : '']),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setTag('')))
          }, _hoisted_5, 2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagList.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.tag,
              class: _normalizeClass(["tag-item", tag.value === item.tag ? 'checked' : '']),
              onClick: ($event: any) => (setTag(item.tag))
            }, [
              _createElementVNode("span", null, _toDisplayString(item.tag.replace(/\\s*|\t|\r|\n/g, ' ')), 1)
            ], 10, _hoisted_6))
          }), 128))
        ])
      ]),
      _createVNode(FilterPopup, {
        filterItems: filterItems,
        hasFilterItems: _unref(hasFilterItems),
        top: _unref(filterPopupTop),
        "onUpdate:filterItems": updateFilterItems
      }, null, 8, ["filterItems", "hasFilterItems", "top"])
    ]),
    _createElementVNode("div", {
      class: "filter-wrapper",
      ref_key: "filterWrap",
      ref: filterWrap
    }, null, 512),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_unref(productListAfterFilter).length)
          ? (_openBlock(), _createBlock(_unref(RadioGroup), {
              key: 0,
              modelValue: checkedActivityGuid.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((checkedActivityGuid).value = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productListAfterFilter), (product) => {
                  return (_openBlock(), _createBlock(_unref(Radio), {
                    key: product.guid,
                    name: product.exchange_activity_guid,
                    class: "device-item xag-flex",
                    "checked-color": checkColor
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ActivityProduct, {
                        name: product.name,
                        images: product.images,
                        child: product.child,
                        onUpdatePopupShow: onUpdatePopupShow,
                        showMore: ""
                      }, {
                        "info-extra": _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, [
                            _createTextVNode(" ￥" + _toDisplayString(product.price) + " ", 1),
                            _hoisted_10
                          ])
                        ]),
                        _: 2
                      }, 1032, ["name", "images", "child"])
                    ]),
                    _: 2
                  }, 1032, ["name"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ]),
      (!_unref(productListAfterFilter).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", null, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(hasFilterItems) ? '暂无符合筛选条件的套装' : '暂无数据'), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (!popupsShow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_unref(Checkbox), {
              modelValue: termsAgreed.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((termsAgreed).value = $event)),
              "icon-size": "16px",
              "checked-color": checkColor,
              shape: "square"
            }, null, 8, ["modelValue"]),
            _hoisted_16,
            _createElementVNode("span", {
              class: "protocol",
              onClick: checkProtocol
            }, "《极飞农业无人机优惠购机须知》")
          ]),
          _createVNode(_unref(Button), {
            square: "",
            type: "success",
            class: "xa-vant-button",
            disabled: !_unref(canSubmit),
            onClick: sumbit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(buttonText)), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true),
    _hoisted_17
  ], 64))
}
}

})